import { usePublicRecordsForCraftsmanOrderArgs } from './usePublicRecordsForCraftsmanOrderArgs.ts';
import { usePublicRecordsFromListings } from './usePublicRecordsFromListings.ts';
import { useTkv2OrderID } from './useTkv2OrderID.ts';

export function usePublicRecordsForOrder() {
  const orderID = useTkv2OrderID();
  const { listings, addressesByID } = usePublicRecordsForCraftsmanOrderArgs();

  return usePublicRecordsFromListings({ orderID }, listings, addressesByID);
}
